module.exports = __webpack_public_path__ + "media/images/bg/headers/gold-fish-2b7cb8319d522d84ddbc0aee1939012d.png";